import { render, staticRenderFns } from "./DriverAssistant.vue?vue&type=template&id=3381ea75&scoped=true&"
import script from "./DriverAssistant.vue?vue&type=script&lang=js&"
export * from "./DriverAssistant.vue?vue&type=script&lang=js&"
import style0 from "./DriverAssistant.vue?vue&type=style&index=0&id=3381ea75&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3381ea75",
  null
  
)

export default component.exports